<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <ValidationObserver slim v-slot="{ invalid }">
        <signup-card>
          <h2 class="title text-center" slot="title">
            Dobrodošli {{ user.email }} !
          </h2>

          <div
            class="md-layout md-layout-item md-size-40 mx-auto"
            slot="content-center"
          >
            <ValidationProviderExtended
              name="Ime"
              rules="required|min:2"
              className="md-form-group md-layout-item md-size-50"
            >
              <md-icon> person </md-icon>
              <label> Ime </label>

              <md-input v-model="user.firstName" type="text"> </md-input>
            </ValidationProviderExtended>
            <ValidationProviderExtended
              name="Prezime"
              rules="required|min:2"
              className="md-layout-item md-size-50"
            >
              <label> Prezime </label>

              <md-input v-model="user.lastName" type="text"> </md-input>
            </ValidationProviderExtended>

            <md-field class="md-form-group md-layout-item md-size-100">
              <md-icon> group </md-icon>

              <span class="form-control-static">{{ user.group }}</span>
            </md-field>

            <ValidationProviderExtended
              name="Radno mjesto"
              rules="required|min:2"
              className="md-form-group md-layout-item md-size-100"
            >
              <md-icon> engineering </md-icon>
              <label> Radno mjesto </label>

              <md-input
                v-model="user.position"
                type="text"
                name="position"
              ></md-input>
            </ValidationProviderExtended>

            <ValidationProviderExtended
              name="Kontakt"
              rules="required|min:2"
              className="md-form-group md-layout-item md-size-100"
            >
              <md-icon>settings_phone</md-icon>
              <label>Kontakt</label>
              <md-input v-model="user.contactNumber" type="text"></md-input>
            </ValidationProviderExtended>

            <ValidationProviderExtended
              name="Lozinka"
              rules="min:8|hasSmallLetter|hasCapitalLetter|hasNumber"
              className="md-form-group md-layout-item"
            >
              <md-icon>lock_outline</md-icon>
              <label>Lozinka</label>
              <md-input
                v-model="user.password"
                type="password"
                name="password"
              ></md-input>
            </ValidationProviderExtended>

            <div class="md-layout-item md-size-100 register-button-container">
              <md-button
                @click="register"
                class="md-offset md-info"
                :disabled="invalid"
              >
                <md-icon>login</md-icon>
                Registruj se!
              </md-button>
            </div>
          </div>
        </signup-card>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { SignupCard } from '@/components';
import services from '@/api/services';
import api from '@/api/api.js';
import Swal from 'sweetalert2';
import ValidationProviderExtended from '@/components/ValidationProviderExtended.vue';
export default {
  components: {
    SignupCard,
    ValidationProviderExtended,
  },
  data() {
    return {
      user: {
        firstName: '',
        lastName: '',
        email: null,
        group: null,
        contactNumber: '',
        password: '',
        position: '',
      },
    };
  },
  methods: {
    register() {
      const requestParams = Object.assign(this.user, {
        authKey: this.$route.query.key,
      });
      api
        .post(services.users.register, {
          activateUser: true,
          user: JSON.stringify(requestParams),
        })
        .then((data) => {
          if (data.registered) {
            Swal.fire({
              title: 'Uspješna prijava!',
              text: `${this.user.firstName}, uspješno ste se prijavili`,
              timer: 2000,
              showConfirmButton: false,
            }).then(() => {
              this.$router.push({ path: `files` });
            });
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            Swal.fire({
              title: 'Korisnik ulogovan',
              text: 'Na uredjaju je već ulogovan drugi korisnik. Molimo vas da se odjavite i pokušate ponovo.',
              showConfirmButton: true,
              confirmButtonText: 'OK!',
              confirmButtonClass: 'md-button md-success btn-fill',
            });
          }
        });
    },
  },
  mounted() {
    if (!this.$route.query.key) {
      this.$router.push({ path: `login` });
    } else {
      api
        .get(services.users.userForKey, {
          userForKey: true,
          key: this.$route.query.key,
        })
        .then((data) => {
          if (data.user) {
            this.user.email = data.user.email;
            this.user.group = data.user.group;
          } else {
            this.$router.push({ path: `login` });
          }
        })
        .catch((error) => {
          this.alertError(error);
        });
    }
  },
};
</script>
<style scoped>
.register-button-container {
  margin-top: 3em !important;
}
.form-control-static {
  padding-left: 2em !important;
  font-size: 1.3em;
}
</style>
